module.exports = __webpack_public_path__ + "static/media/privacy-week-splash.33b8ffeb.jpg";